<template>
  <div class="relative flex items-center">
    <div class="absolute pl-3 text-gray-500" style="top:50%;transform:translateY(-50%)">
      <font-awesome-icon :icon="['far', 'search']"></font-awesome-icon>
    </div>
    <input ref="input" class="pl-8 pr-4 w-48 bg-white rounded-full focus:bg-white" type="text" :value="value" @input="onSearch" placeholder="Søk" />
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: ['value'],
  methods: {
    onSearch () {
      this.$emit('input', this.$refs.input.value)
    }
  }
}
</script>